import React, { memo } from "react";
import { View } from "react-native";

interface GapProps {
  gap: number;
}
const Gap = memo<GapProps>(function Gap({ gap }) {
  return <View style={{ marginTop: gap }} />;
});

export default Gap;
